import { render, staticRenderFns } from "./DefaultPaymentMethodTable.vue?vue&type=template&id=7c70f3ca&scoped=true&"
import script from "./DefaultPaymentMethodTable.vue?vue&type=script&lang=js&"
export * from "./DefaultPaymentMethodTable.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/enterprise_setting_table.css?vue&type=style&index=0&id=7c70f3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70f3ca",
  null
  
)

export default component.exports